import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
    app: 'Lamara',
    plugins: [
        googleTagManager({
        containerId: 'GTM-5XMZRXN'
        }),
        googleAnalytics({
            trackingId: 'UA-212735295-1'
        })
    ]
})

export default analytics;